// extracted by mini-css-extract-plugin
export default {"productCarousel":"f0-z"};